var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuiz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.25 10.775V15.7738L12.3376 17.453C12.1168 17.5157 11.8832 17.5157 11.6624 17.453L5.75 15.7738V10.775L11.6624 12.453C11.828 12.5 12.0008 12.5118 12.17 12.4882L12.3376 12.453L18.25 10.775ZM12.3376 2.54702L21.0867 5.03074C21.6392 5.1876 22.0005 5.69659 22 6.2505V6.25V12.5C22 13.1904 21.4404 13.75 20.75 13.75C20.0596 13.75 19.5 13.1904 19.5 12.5V7.91875L12.3376 9.95298C12.1168 10.0157 11.8832 10.0157 11.6624 9.95298L2.91331 7.46926C2.24826 7.28046 1.86029 6.58153 2.04675 5.90815C2.16459 5.4826 2.49303 5.15005 2.91331 5.03074L11.6624 2.54702C11.8832 2.48433 12.1168 2.48433 12.3376 2.54702Z",
    fill: "#1B3380"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuiz);
export default __webpack_public_path__ + "static/media/quiz.fc0a125b0786ad8aa60a57b0a10ce015.svg";
export { ForwardRef as ReactComponent };